// App.jsx (no BrowserRouter here)
import { Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import LoginForm from "./LoginForm";
import RegisterStore from "./RegisterStore";
import Dashboard from "./Dashboard";
import PosRunner from "./PosRunner";
import { setStoreIdHeader, setUserHeader } from "./api";

function getUserObj() {
  const raw = localStorage.getItem("user") || "";
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function hasPerm(userObj, perm) {
  const p = userObj?.permissions || userObj?.user?.permissions || [];
  return Array.isArray(p) && p.includes(perm);
}

function isSuperUser(userObj) {
  // supports different shapes: {role} or {user:{role}}
  const role = (userObj?.role || userObj?.user?.role || "").toLowerCase();
  if (role === "super_user" || role === "superuser" || role === "super") return true;

  // OR permission-based
  return hasPerm(userObj, "store.register") || hasPerm(userObj, "store.create");
}

function RequireAuth() {
  const location = useLocation();
  const user = localStorage.getItem("user");
  const sid = Number(localStorage.getItem("store_id") || 0);

  if (!user || !sid) return <Navigate to="/login" replace state={{ from: location }} />;

  // ✅ keep headers in sync for all authenticated routes
  const userObj = getUserObj();
  const username =
    userObj?.user?.username ||
    userObj?.username ||
    localStorage.getItem("username") ||
    "";

  setStoreIdHeader(sid);
  setUserHeader(username);

  return <Outlet />;
}

// ✅ only super_user can access store registration
function RequireSuperUser() {
  const location = useLocation();
  const userObj = getUserObj();

  if (!userObj) return <Navigate to="/login" replace state={{ from: location }} />;

  if (!isSuperUser(userObj)) {
    // send them to dashboard instead of allowing register-store
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route path="/login" element={<LoginForm />} />

      {/* super_user only */}
      <Route element={<RequireSuperUser />}>
        <Route path="/register-store" element={<RegisterStore />} />
      </Route>

      <Route path="/register" element={<Navigate to="/register-store" replace />} />

      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pos" element={<PosRunner />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}